import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { UserService } from '../../_services/user.service';
import {CommonService} from '../../_services/common.service';
import { NotificationService, NotificationType } from '../../_services/notification.service';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loading = false;
  multiFactorAuthEnabled = false;
  otpExpirationTime: number;
  model: any = {};
  public passwordShow;
  expTimeOutObject: any;
  ssoList: any = [];
  constructor(private _route: ActivatedRoute,
    private _router: Router,
    private _authService: AuthService,
    private _notificationService: NotificationService,
    private _commonService: CommonService,
    private _userService: UserService) { }

  returnUrl: string;
  token: string;
  exp: string;
  refreshToken: string;
  credentials: any;
  sso_enable: any;

  loginform = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.minLength(3)]),
    password: new FormControl('', [Validators.required, Validators.minLength(4)]),
    otp: new FormControl('')
  });
  



  ngOnInit() {
    this.getSSOList()
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/list-va';
    this.token = this._route.snapshot.queryParams['token'] || null;
    this.exp = this._route.snapshot.queryParams['exp'] || null;
    this.refreshToken = this._route.snapshot.queryParams['refresh_token'] || null;
    this.sso_enable = this._route.snapshot.queryParams['sso_enable'] || 'false';
    if(this.token){
      console.log("===== ===== ==== ==== login tokens",this.token);
      localStorage.setItem('currentUser', JSON.stringify({
        "token": this.token,
        "exp": this.exp,
        "refresh_token": this.refreshToken,
        'sso_enable': this.sso_enable,
        "expirationTime": new Date().setHours(new Date().getHours() + parseInt(this.exp.split(":")[0]))
      }))
      this._userService.tokenExpirationTimeOut();
      this._router.navigate([this.returnUrl]);
    }
  }

  getSSOList(){
    this._authService.getSSOList().subscribe(res=>{
      this.ssoList = res;
    })
  }

  login() {
    this.loading = true;
    let notificationID = this._notificationService.showNotification({
      message: "Checking..",
      type: NotificationType.info,
      isLoading: true
    });
    this._notificationService.notificationID.push(notificationID);

    // encripting data
    this.credentials = {'test': 'test', 'tests': 'reser'};
    console.log('Credentials');
    console.log(environment)
    console.log(this.credentials);
    console.log(this._commonService.encryptData(this.credentials));
    console.log(this.loginform.get('username'));

    const username_encripted =  this._commonService.encryptData(this.loginform.get('username').value);
    const pwd_encripted =  this._commonService.encryptData(this.loginform.get('password').value);

    if (this.multiFactorAuthEnabled) {
      this.loginWithMFA(username_encripted, pwd_encripted);
    } else {

      this._authService.login(username_encripted, pwd_encripted, true)
        .subscribe( (result: any) => {

          if (result.mfa) {
            let notifyID = this._notificationService.notificationID.shift();
            this._notificationService.changeStatus(notifyID, NotificationType.success, "Success");
            this.multiFactorAuthEnabled = true;
            this.otpExpirationTime = result.otp_expiration_time;
            this.loading = false;
          } else {
            this._userService.tokenExpirationTimeOut();
            let notifyID = this._notificationService.notificationID.shift();
            this._notificationService.changeStatus(notifyID, NotificationType.success, "Success");
            this.loading = false;
            this._router.navigateByUrl(this.returnUrl);
          }
        },
          error => {
            this.loading = false;
            if (error.status === 406) {
              let notifyID = this._notificationService.notificationID.shift();
              this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
              this._router.navigateByUrl('auth/set-new-password/' + error.error.token)
            } else if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
              let notifyID = this._notificationService.notificationID.shift();
              this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
            }
            this.loginform.reset();
      });
    }
  }

  loginWithMFA(username_encripted, pwd_encripted) {
    if (this.loginform.get('otp').value) {
      const otp =  this.loginform.get('otp').value;
      this._authService.login(username_encripted, pwd_encripted, true, otp)
      .subscribe( (result: any) => {
          this._userService.tokenExpirationTimeOut();
          let notifyID = this._notificationService.notificationID.shift();
          this._notificationService.changeStatus(notifyID, NotificationType.success, "Success");
          this.loading = false;
          this.multiFactorAuthEnabled = false;
          this._router.navigateByUrl(this.returnUrl);
      },
        error => {
          this.loading = false;
          let notifyID = this._notificationService.notificationID.shift();
          this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
      });
    }
  }

  resendOTP() {
    this.loginform.get('otp').setValue("");
    this._authService.resendOTP(this.loginform.get('username').value).subscribe(
      result => {
        this._notificationService.showNotification({
          message: 'A new OTP has been sent to your registered email address',
          type: NotificationType.success,
          isLoading: false
        });
      }, err => {
        console.log(err.error.message);
        this._notificationService.showNotification({
          message: 'something went wrong',
          type: NotificationType.error,
          isLoading: false
        });
      }
    );
  }
  openSSO(url){
    window.history.pushState(null, null, location.origin)
      window.location = url;

  }

}
